export default "__VITE_ASSET__034b2ed4__"